import React from "react";

import { Box } from "@mui/material";

// import Image from "root/components/Image";
import Tooltip_ from "root/components/Tooltip";

import { instagramDisclaimer } from "..";

import dzen from "./dzen.svg";
import instagram from "./instagram.svg";
import telegram from "./telegram.svg";
import tiktok from "./tiktok.svg";
import vkontakte from "./vkontakte.svg";
import wibes from "./wibes.svg";
import youtube from "./youtube.svg";

const InstagramIconWithMark = props => {
  return (
    <Tooltip_ title={instagramDisclaimer} placement="bottom">
      <Box display={"flex"} alignItems={"center"}>
        <img {...props} src={instagram} />
      </Box>
    </Tooltip_>
  );
};

const DefaultImage = props => <img width={24} height={24} {...props} />;

const DzenIcon = props => <DefaultImage {...props} src={dzen} />;
const TelegramIcon = props => <DefaultImage {...props} src={telegram} />;
const TikTokIcon = props => <DefaultImage {...props} src={tiktok} />;
const YouTubeIcon = props => <DefaultImage {...props} src={youtube} />;
const VKontakteIcon = props => <DefaultImage {...props} src={vkontakte} />;
const WibesIcon = props => <DefaultImage {...props} src={wibes} />;

const socialNetworksIcons = {
  instagram: { default: <InstagramIconWithMark /> },
  dzen: { default: <DzenIcon /> },
  telegram: { default: <TelegramIcon /> },
  tiktok: { default: <TikTokIcon /> },
  youtube: { default: <YouTubeIcon /> },
  vkontakte: { default: <VKontakteIcon /> },
  wibes: { default: <WibesIcon /> },
};

export {
  InstagramIconWithMark,
  DzenIcon,
  TelegramIcon,
  TikTokIcon,
  YouTubeIcon,
  VKontakteIcon,
  WibesIcon,
  socialNetworksIcons,
};
